import React, { useEffect } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import { mdiAlignVerticalBottom } from "@mdi/js";

import { useInput } from "../../../../../hooks/useInput";
import { Button } from "../../../../../components/Button";
import { Checkbox } from "../../../../../components/Checkbox";
import { useOnChange } from "../../../../../hooks/useOnChange";
import { InputText } from "../../../../../components/InputText";
import { InputNumber } from "../../../../../components/InputNumber";
import calcAreaUtils from "../../../../../../script/utils/calcAreaUtils";

const AreaItemStyle = styled.div`
    >div:nth-child(1) {
        margin-bottom: 10px;
        display: grid;
        grid-template-columns: 2.5fr 1fr 1fr;
        gap: 8px;
        align-items: flex-end;
    }
    >div:nth-child(2) {
        display: flex;
        gap: 8px;
        align-items: flex-end;
        justify-content: end;
    }
`;

export const WattwaechterItem = props => {
    const { calcArea, index, shouldDisplay, onVisibilityChanged, boundaryClipped, resultDetails, fieldType, onBoundaryClippedChanged, pointAnalysisResultVisible, onPointAnalysisResultVisibleChanged } = props;

    const inputName = "wattwaechter-result-" + index;
    const nameInput = useInput(inputName + "name", calcArea.name);
    const visibleInput = useInput(inputName + "visible", shouldDisplay);
    const boundaryClippedInput = useInput(inputName + "boundaryClipped", boundaryClipped);
    const heightInput = useInput(inputName + "height",
        calcArea.originZ !== undefined && calcArea.vaxisZ !== undefined ? calcArea.originZ + calcArea.vaxisZ : undefined);
    const heightLowInput = useInput(inputName + "heightLow", calcArea.originZ);
    const gwaValue = (boundaryClipped ?? false) ? resultDetails?.gwaBoundary : resultDetails?.gwa;
    const gwaValueFieldAddjusted = fieldType === "PROTECTION_AREA_BLMSCHV" && gwaValue && gwaValue > 1 ? 1 : gwaValue;
    const gwaValueRounded = gwaValueFieldAddjusted ? Math.round( gwaValueFieldAddjusted * 100) / 100 : gwaValueFieldAddjusted;
    const gwaInput = useInput(inputName + "gwa", gwaValueRounded);
    const pointAnalysisVisibleInput = useInput(inputName + "pointAnalysisVisible", pointAnalysisResultVisible);

    useOnChange((_, value) => {
        onVisibilityChanged(value);
    }, [visibleInput]);

    useOnChange((_, value) => {
        onBoundaryClippedChanged(value);
    }, [boundaryClippedInput]);

    useEffect(() => {
        const criticalValue = 1.0;
        if(gwaInput.value !== undefined && gwaInput.value !== null && gwaInput.value >= criticalValue) {
            gwaInput.setError(true);
            gwaInput.setErrorVisible(true);
        } else {
            gwaInput.setError(false);
            gwaInput.setErrorVisible(false);
        }
    }, [gwaInput.value]);

    useOnChange((_, value) => {
        onPointAnalysisResultVisibleChanged(value);
    }, [pointAnalysisVisibleInput]);

    return (
        <AreaItemStyle>
            <div>
                <InputText {...nameInput.bind}
                    disabled={true}
                    title={intl.get("entry.plan.wattwaechter.name")} />
                <InputNumber {...heightInput.bind}
                    disabled={true}
                    title={intl.get("entry.plan.wattwaechter.height")}
                    fractionDigits={2} />
                <InputNumber {...heightLowInput.bind}
                    disabled={true}
                    title={intl.get("entry.plan.wattwaechter.heightLow")}
                    fractionDigits={2} />
            </div>
            <div>
                <div style={{width: "60px", marginRight: "auto"}}>
                    <InputNumber {...gwaInput.bind}
                        disabled={true}
                        title={intl.get("entry.plan.wattwaechter.gwa")}
                        fractionDigits={2} />
                </div>
                { pointAnalysisResultVisible !== undefined &&
                    <Checkbox {...pointAnalysisVisibleInput.bind}
                        title={intl.get("entry.plan.wattwaechter.pointAnalysisVisible")} />
                }
                <Checkbox {...visibleInput.bind}
                    title={intl.get("entry.plan.wattwaechter.visible")} />
                <Checkbox {...boundaryClippedInput.bind}
                    disabled={!calcArea.boundary || calcAreaUtils.isVertical(calcArea)}
                    title={intl.get("entry.plan.wattwaechter.boundaryClipped")} />
                <Button
                    compact
                    svgIcon={mdiAlignVerticalBottom}
                    onClick={props.onResultDialog} />
            </div>
        </AreaItemStyle>
    );
};